import React, { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getIndividualBusiness } from "../../../redux/reducers/businessSlice";
import Basic from "./tabs/Basic";
import BusinessInformation from "./tabs/BusinessInformation";
import PaymentSetting from "./tabs/PaymentSetting";
import GeneralSettings from "./tabs/GeneralSettings";

export default function BusinessInfo() {
  const [key, setKey] = useState("one");
  useEffect(() => {
    const getActiveTab = JSON.parse(localStorage.getItem("activeTab"));
    if (getActiveTab) {
      setKey(getActiveTab);
    }
  }, []);
  useEffect(() => {
    localStorage.setItem("activeTab", JSON.stringify(key));
  }, [key]);

  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getIndividualBusiness(id));
  }, [dispatch, id]);

  const businessdata = useSelector(
    (state) => state.business.individualBusiness
  );

  return (
    <div>
      <div className="container mt-5">
        <div className="row">
          <div className="col-12">
            <div className="pageTitle">
              <h1>Business Info</h1>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="col-12">
          <Tabs
            //defaultActiveKey='one'
            id="businessAdd-tab"
            className="addBusiness-tab my-4"
            activeKey={key}
            onSelect={(k) => setKey(k)}
          >
            <Tab
              eventKey="one"
              className="addBusiness-content"
              title="Basic Information"
            >
              <Basic data={businessdata} />
            </Tab>



            <Tab
              eventKey="two"
              className="addBusiness-content"
              title="Business Information"
            >
              <BusinessInformation data={businessdata?.invoiceSettings} businessId={id} />
            </Tab>
            <Tab
              eventKey="three"
              className="addBusiness-content"
              title="Payment Settings"
            >
              {/* <Address data={businessdata?.addressInfo} /> */}
              <PaymentSetting data={businessdata}
              />
            </Tab>
            <Tab
              eventKey="four"
              className="addBusiness-content"
              title="General Settings"
            >
              <GeneralSettings businessId={id} />
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>
  );
}
